import checkout from "./form";

const {
  formField: { taxId, conpanyName, releaseDate, representative, why, address, date },
} = checkout;

const initialValues = {
  [taxId.name]: "",
  [conpanyName.name]: "",
  [releaseDate.name]: "",
  [representative.name]: "",
  [why.name]: "",
  [address.name]: "",
  [date.name]: "",
};

export default initialValues;
